export const DEFAULT_TEST_INPUT = `The price is higher than our budget.
Delivery time does not meet our deadline.
We found a more affordable alternative.
Unclear scope of work in the provided quote.
Concerns about the quality of previous work.`;
